import { foundation } from './tokens';

/**
 * ONE row height for every desktop list table (KAN-696, founder 2026-10-07):
 * Jobs, Facturación (All invoices, Collect), Presupuestos, Clientes, Catálogo —
 * admin and billing. A row's height used to fall out of whatever was tallest
 * inside it (an "Acciones" button vs a ⋮ vs a pill), so sibling lists drifted
 * 41 vs 42 vs 57px. A `<td>` height acts as the row's minimum, so taller
 * content can still grow a row; nothing shorter can shrink it.
 *
 * Use `desktopListRowCell(base)` for every body `<td>` of those tables — never a
 * local vertical padding or height. Only the row HEIGHT is shared: a table keeps
 * its own side gutter via `{ padX }` (Clientes/Catálogo 12px, the rest 16px).
 * Guard: `desktopListRowHeight.guard.test.js`.
 */
export const DESKTOP_LIST_ROW_HEIGHT_PX = 44;
export const DESKTOP_LIST_CELL_PADDING = `${foundation.spacePx[1]} ${foundation.spacePx[4]}`;

/**
 * The same 44px row for lists drawn as CSS-grid `div` rows instead of a <table> (Platform → Companies,
 * Platform → AI usage): a MINIMUM height (a div has no <td> semantics, so a fixed height would clip
 * taller content) with the shared vertical padding. `padX` = the list's own side gutter.
 */
export function desktopListGridRow(base = {}, { padX = foundation.spacePx[4] } = {}) {
  return {
    ...base,
    minHeight: DESKTOP_LIST_ROW_HEIGHT_PX,
    padding: `${foundation.spacePx[1]} ${padX}`,
    boxSizing: 'border-box',
  };
}

export function desktopListRowCell(base = {}, { padX } = {}) {
  return {
    ...base,
    height: DESKTOP_LIST_ROW_HEIGHT_PX,
    padding: padX ? `${foundation.spacePx[1]} ${padX}` : DESKTOP_LIST_CELL_PADDING,
    verticalAlign: 'middle',
    boxSizing: 'border-box',
  };
}
